import React from 'react';

function AstrologyContent({ astroTab: astroTabProp, lang: langProp }) {
  // Dual-mode. When a parent passes astroTab/lang (AppMain), the component is
  // "controlled" and hides its own tab bar. When rendered with no props
  // (WatchNowPage — the live view), it is self-contained: its own tab bar and
  // language toggle drive internal state.
  const controlled = astroTabProp !== undefined;
  const [internalTab, setInternalTab] = React.useState("Panchangam");
  const [internalLang, setInternalLang] = React.useState("ta");
  const astroTab = controlled ? astroTabProp : internalTab;
  const lang = langProp !== undefined ? langProp : internalLang;
  const [selectedRasi, setSelectedRasi] = React.useState(null);
  const [selectedNakshatra, setSelectedNakshatra] = React.useState(null);

  const today = new Date();
  const days = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
  const tamilDays = ["ஞாயிறு","திங்கள்","செவ்வாய்","புதன்","வியாழன்","வெள்ளி","சனி"];
  const dayIndex = today.getDay();

  const rahuKalam = {"0":"4:30 PM - 6:00 PM","1":"7:30 AM - 9:00 AM","2":"3:00 PM - 4:30 PM","3":"12:00 PM - 1:30 PM","4":"1:30 PM - 3:00 PM","5":"10:30 AM - 12:00 PM","6":"9:00 AM - 10:30 AM"};
  const yamagandam = {"0":"12:00 PM - 1:30 PM","1":"10:30 AM - 12:00 PM","2":"9:00 AM - 10:30 AM","3":"7:30 AM - 9:00 AM","4":"6:00 PM - 7:30 PM","5":"3:00 PM - 4:30 PM","6":"1:30 PM - 3:00 PM"};
  const gulikai = {"0":"3:00 PM - 4:30 PM","1":"1:30 PM - 3:00 PM","2":"12:00 PM - 1:30 PM","3":"10:30 AM - 12:00 PM","4":"9:00 AM - 10:30 AM","5":"7:30 AM - 9:00 AM","6":"6:00 AM - 7:30 AM"};

  const nakshatras = [
    {name:"Ashwini",tamil:"அஸ்வினி",planet:"Ketu",qualities:"Swift, Healing, New Beginnings"},
    {name:"Bharani",tamil:"பரணி",planet:"Venus",qualities:"Creative, Transformative, Passionate"},
    {name:"Krittika",tamil:"கிருத்திகை",planet:"Sun",qualities:"Sharp, Purifying, Determined"},
    {name:"Rohini",tamil:"ரோகிணி",planet:"Moon",qualities:"Fertile, Beautiful, Prosperous"},
    {name:"Mrigashira",tamil:"மிருகசீரிஷம்",planet:"Mars",qualities:"Searching, Gentle, Curious"},
    {name:"Ardra",tamil:"திருவாதிரை",planet:"Rahu",qualities:"Stormy, Transformative, Powerful"},
    {name:"Punarvasu",tamil:"புனர்பூசம்",planet:"Jupiter",qualities:"Renewal, Optimistic, Generous"},
    {name:"Pushya",tamil:"பூசம்",planet:"Saturn",qualities:"Nourishing, Protective, Devoted"},
    {name:"Ashlesha",tamil:"ஆயில்யம்",planet:"Mercury",qualities:"Mystical, Intense, Perceptive"},
    {name:"Magha",tamil:"மகம்",planet:"Ketu",qualities:"Royal, Ancestral, Authoritative"},
    {name:"Purva Phalguni",tamil:"பூரம்",planet:"Venus",qualities:"Relaxing, Creative, Fortunate"},
    {name:"Uttara Phalguni",tamil:"உத்திரம்",planet:"Sun",qualities:"Service, Helpful, Generous"},
    {name:"Hasta",tamil:"அஸ்தம்",planet:"Moon",qualities:"Skillful, Witty, Clever"},
    {name:"Chitra",tamil:"சித்திரை",planet:"Mars",qualities:"Bright, Creative, Artistic"},
    {name:"Swati",tamil:"சுவாதி",planet:"Rahu",qualities:"Independent, Flexible, Restless"},
    {name:"Vishakha",tamil:"விசாகம்",planet:"Jupiter",qualities:"Purposeful, Ambitious, Focused"},
    {name:"Anuradha",tamil:"அனுஷம்",planet:"Saturn",qualities:"Devoted, Friendly, Spiritual"},
    {name:"Jyeshtha",tamil:"கேட்டை",planet:"Mercury",qualities:"Protective, Eldest, Powerful"},
    {name:"Mula",tamil:"மூலம்",planet:"Ketu",qualities:"Investigative, Destructive, Transformative"},
    {name:"Purva Ashadha",tamil:"பூராடம்",planet:"Venus",qualities:"Invincible, Proud, Philosophical"},
    {name:"Uttara Ashadha",tamil:"உத்திராடம்",planet:"Sun",qualities:"Victory, Responsible, Principled"},
    {name:"Shravana",tamil:"திருவோணம்",planet:"Moon",qualities:"Listening, Learning, Connecting"},
    {name:"Dhanishtha",tamil:"அவிட்டம்",planet:"Mars",qualities:"Wealthy, Musical, Ambitious"},
    {name:"Shatabhisha",tamil:"சதயம்",planet:"Rahu",qualities:"Healing, Secretive, Scientific"},
    {name:"Purva Bhadrapada",tamil:"பூரட்டாதி",planet:"Jupiter",qualities:"Fiery, Transformative, Passionate"},
    {name:"Uttara Bhadrapada",tamil:"உத்திரட்டாதி",planet:"Saturn",qualities:"Deep, Stable, Spiritual"},
    {name:"Revati",tamil:"ரேவதி",planet:"Mercury",qualities:"Nourishing, Protective, Spiritual"}
  ];

  const rasis = [
    {name:"Aries",tamil:"மேஷம்",symbol:"&#9800;",lord:"Mars",element:"Fire",pred:"New opportunities ahead. Focus on health and career. Avoid conflicts.",tamilPred:"புதிய வாய்ப்புகள் வரும். உடல் ஆரோக்கியத்தில் கவனம் செலுத்துங்கள்."},
    {name:"Taurus",tamil:"ரிஷபம்",symbol:"&#9801;",lord:"Venus",element:"Earth",pred:"Financial matters need attention. Good time for investments.",tamilPred:"நிதி விஷயங்களில் கவனம் தேவை. முதலீட்டிற்கு நல்ல நேரம்."},
    {name:"Gemini",tamil:"மிதுனம்",symbol:"&#9802;",lord:"Mercury",element:"Air",pred:"Communication skills shine. Short journeys prove beneficial.",tamilPred:"தகவல் தொடர்பு திறன் வளரும். குறுகிய பயணங்கள் பயனுள்ளதாக இருக்கும்."},
    {name:"Cancer",tamil:"கடகம்",symbol:"&#9803;",lord:"Moon",element:"Water",pred:"Emotional balance is key. Home and family matters take priority.",tamilPred:"உணர்ச்சி சமநிலை முக்கியம். குடும்ப விஷயங்கள் முன்னுரிமை பெறும்."},
    {name:"Leo",tamil:"சிம்மம்",symbol:"&#9804;",lord:"Sun",element:"Fire",pred:"Leadership qualities emerge. Creative projects succeed.",tamilPred:"தலைமைத்துவ குணங்கள் வெளிப்படும். படைப்பாற்றல் திட்டங்கள் வெற்றி பெறும்."},
    {name:"Virgo",tamil:"கன்னி",symbol:"&#9805;",lord:"Mercury",element:"Earth",pred:"Detail-oriented work brings rewards. Health improvements likely.",tamilPred:"விவரமான வேலை வெகுமதி தரும். உடல் ஆரோக்கியம் மேம்படும்."},
    {name:"Libra",tamil:"துலாம்",symbol:"&#9806;",lord:"Venus",element:"Air",pred:"Balance in relationships brings harmony. Legal matters resolve favorably.",tamilPred:"உறவுகளில் சமநிலை நல்லிணக்கம் தரும். சட்ட விஷயங்கள் சாதகமாக முடியும்."},
    {name:"Scorpio",tamil:"விருச்சிகம்",symbol:"&#9807;",lord:"Mars",element:"Water",pred:"Deep transformation occurs. Hidden matters come to light.",tamilPred:"ஆழமான மாற்றம் நிகழும். மறைந்திருந்த விஷயங்கள் வெளிவரும்."},
    {name:"Sagittarius",tamil:"தனுசு",symbol:"&#9808;",lord:"Jupiter",element:"Fire",pred:"Philosophy and travel expand horizons. Higher education brings rewards.",tamilPred:"தத்துவம் மற்றும் பயணம் அறிவை விரிவடையச் செய்யும்."},
    {name:"Capricorn",tamil:"மகரம்",symbol:"&#9809;",lord:"Saturn",element:"Earth",pred:"Hard work and discipline pay off. Career advancement is imminent.",tamilPred:"கடின உழைப்பும் ஒழுக்கமும் பலன் தரும். தொழில் முன்னேற்றம் உறுதி."},
    {name:"Aquarius",tamil:"கும்பம்",symbol:"&#9810;",lord:"Saturn",element:"Air",pred:"Humanitarian causes call. Innovation and technology favor you.",tamilPred:"மக்கள் நலன் சார்ந்த காரணங்கள் அழைக்கின்றன. தொழில்நுட்பம் சாதகம்."},
    {name:"Pisces",tamil:"மீனம்",symbol:"&#9811;",lord:"Jupiter",element:"Water",pred:"Spiritual insights deepen. Creative imagination soars.",tamilPred:"ஆன்மீக நுண்ணறிவு ஆழமடையும். படைப்பு கற்பனை உயரும்."}
  ];

  const festivals = [
    {date:"Jan 14",name:"Pongal",tamil:"பொங்கல்",desc:"Harvest festival celebrating Sun God.",tamilDesc:"சூரிய வழிபாட்டு அறுவடை திருவிழா.",type:"major"},
    {date:"Jan 15",name:"Mattu Pongal",tamil:"மாட்டு பொங்கல்",desc:"Day to honor cattle.",tamilDesc:"கால்நடைகளை போற்றும் நாள்.",type:"major"},
    {date:"Feb 26",name:"Maha Shivaratri",tamil:"மகா சிவராத்திரி",desc:"Most sacred night for Lord Shiva.",tamilDesc:"சிவபெருமானுக்கு மிகவும் புனிதமான இரவு.",type:"major"},
    {date:"Mar 14",name:"Tamil New Year",tamil:"தமிழ் புத்தாண்டு",desc:"Tamil New Year - Chithirai 1st.",tamilDesc:"தமிழ் புத்தாண்டு - சித்திரை 1.",type:"major"},
    {date:"Apr 6",name:"Ram Navami",tamil:"ராம நவமி",desc:"Birthday of Lord Rama.",tamilDesc:"இராமர் பிறந்த நாள்.",type:"major"},
    {date:"May 12",name:"Akshaya Tritiya",tamil:"அக்ஷய திருதியை",desc:"Most auspicious day for new beginnings.",tamilDesc:"புதிய தொடக்கங்களுக்கு மிகவும் சுபமான நாள்.",type:"major"},
    {date:"Jun 7",name:"Vaikasi Visakam",tamil:"வைகாசி விசாகம்",desc:"Birth star of Lord Murugan.",tamilDesc:"முருகன் பிறந்த நட்சத்திர நாள்.",type:"major"},
    {date:"Jul 7",name:"Aadi Perukku",tamil:"ஆடி பெருக்கு",desc:"Worship of rivers and water bodies.",tamilDesc:"நதிகள் மற்றும் நீர்நிலைகளை வழிபடும் திருவிழா.",type:"major"},
    {date:"Aug 19",name:"Krishna Jayanti",tamil:"கிருஷ்ண ஜெயந்தி",desc:"Birthday of Lord Krishna.",tamilDesc:"கிருஷ்ண பகவான் பிறந்த நாள்.",type:"major"},
    {date:"Sep 7",name:"Vinayagar Chaturthi",tamil:"விநாயகர் சதுர்த்தி",desc:"Birthday of Lord Ganesha.",tamilDesc:"விநாயகர் பிறந்த நாள்.",type:"major"},
    {date:"Oct 11",name:"Navratri Begins",tamil:"நவராத்திரி",desc:"Nine nights of Goddess worship.",tamilDesc:"ஒன்பது இரவுகள் தேவி வழிபாடு.",type:"major"},
    {date:"Oct 20",name:"Vijayadasami",tamil:"விஜயதசமி",desc:"Victory of Good over Evil.",tamilDesc:"தீமையின் மேல் நன்மையின் வெற்றி.",type:"major"},
    {date:"Oct 28",name:"Diwali",tamil:"தீபாவளி",desc:"Festival of Lights.",tamilDesc:"விளக்குத் திருவிழா.",type:"major"},
    {date:"Nov 15",name:"Karthigai Deepam",tamil:"கார்த்திகை தீபம்",desc:"Light lamps for Lord Shiva and Murugan.",tamilDesc:"சிவபெருமான் மற்றும் முருகனுக்கு விளக்கேற்றுங்கள்.",type:"major"},
  ];

  const pournami = [
    {date:"Jan 13",day:"Tuesday",tamil:"தை பௌர்ணமி"},
    {date:"Feb 12",day:"Thursday",tamil:"மாசி பௌர்ணமி"},
    {date:"Mar 13",day:"Friday",tamil:"பங்குனி பௌர்ணமி"},
    {date:"Apr 12",day:"Sunday",tamil:"சித்திரை பௌர்ணமி"},
    {date:"May 12",day:"Tuesday",tamil:"வைகாசி பௌர்ணமி"},
    {date:"Jun 11",day:"Thursday",tamil:"ஆனி பௌர்ணமி"},
    {date:"Jul 10",day:"Friday",tamil:"ஆடி பௌர்ணமி"},
    {date:"Aug 9",day:"Sunday",tamil:"ஆவணி பௌர்ணமி"},
    {date:"Sep 7",day:"Monday",tamil:"புரட்டாசி பௌர்ணமி"},
    {date:"Oct 7",day:"Wednesday",tamil:"ஐப்பசி பௌர்ணமி"},
    {date:"Nov 5",day:"Thursday",tamil:"கார்த்திகை பௌர்ணமி"},
    {date:"Dec 4",day:"Friday",tamil:"மார்கழி பௌர்ணமி"},
  ];

  const amavasai = [
    {date:"Jan 29",day:"Thursday",tamil:"தை அமாவாசை"},
    {date:"Feb 28",day:"Saturday",tamil:"மாசி அமாவாசை"},
    {date:"Mar 29",day:"Sunday",tamil:"பங்குனி அமாவாசை"},
    {date:"Apr 27",day:"Monday",tamil:"சித்திரை அமாவாசை"},
    {date:"May 27",day:"Wednesday",tamil:"வைகாசி அமாவாசை"},
    {date:"Jun 25",day:"Thursday",tamil:"ஆனி அமாவாசை"},
    {date:"Jul 24",day:"Friday",tamil:"ஆடி அமாவாசை"},
    {date:"Aug 23",day:"Sunday",tamil:"ஆவணி அமாவாசை"},
    {date:"Sep 21",day:"Monday",tamil:"புரட்டாசி அமாவாசை"},
    {date:"Oct 21",day:"Wednesday",tamil:"ஐப்பசி அமாவாசை"},
    {date:"Nov 20",day:"Friday",tamil:"கார்த்திகை அமாவாசை"},
    {date:"Dec 19",day:"Saturday",tamil:"மார்கழி அமாவாசை"},
  ];

  const TABS = ["Panchangam","Calendar","Festivals","Rasi","Nakshatra","Rahu Kalam","Muhurtham","Learn"];

  const goldBtn = (active) => ({
    padding:"7px 14px",
    background:active?"linear-gradient(135deg,#d4a843,#a07820)":"transparent",
    border:"1px solid rgba(212,168,67,0.4)",
    color:active?"#000":"#d4a843",
    borderRadius:"20px",
    cursor:"pointer",
    fontSize:"11px",
    fontWeight:700,
    whiteSpace:"nowrap"
  });

  const card = {
    background:"linear-gradient(135deg,#0a0020,#050010)",
    border:"1px solid rgba(212,168,67,0.2)",
    borderRadius:"8px",
    padding:"14px"
  };

  const secTitle = (t) => (
    React.createElement('div', {style:{display:"flex",alignItems:"center",gap:"10px",margin:"18px 0 12px"}},
      React.createElement('div', {style:{height:"1px",flex:1,background:"linear-gradient(90deg,#d4a843,transparent)"}}),
      React.createElement('span', {style:{color:"#d4a843",fontWeight:900,fontSize:"11px",letterSpacing:"3px"}}, t),
      React.createElement('div', {style:{height:"1px",flex:1,background:"linear-gradient(90deg,transparent,#d4a843)"}})
    )
  );

  return (
    <div>
      {!controlled && (
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"14px",flexWrap:"wrap",gap:"8px"}}>
          <div style={{display:"flex",gap:"6px",flexWrap:"wrap"}}>
            {TABS.map(tab => <button key={tab} style={goldBtn(astroTab===tab)} onClick={()=>setInternalTab(tab)}>{tab}</button>)}
          </div>
          <div style={{display:"flex",gap:"6px"}}>
            <button style={goldBtn(lang==="ta")} onClick={()=>setInternalLang("ta")}>Tamil</button>
            <button style={goldBtn(lang==="en")} onClick={()=>setInternalLang("en")}>English</button>
          </div>
        </div>
      )}
      {astroTab==="Panchangam" && (
        <div>
          {secTitle(lang==="ta"?"இன்றைய பஞ்சாங்கம்":"TODAY'S PANCHANGAM")}
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(150px,1fr))",gap:"10px",marginBottom:"16px"}}>
            {[
              {l:lang==="ta"?"வாரம்":"Vara",v:lang==="ta"?tamilDays[dayIndex]:days[dayIndex],icon:"&#9737;"},
              {l:lang==="ta"?"தேதி":"Date",v:today.toLocaleDateString("en-IN",{day:"numeric",month:"long"}),icon:"&#128197;"},
              {l:lang==="ta"?"திதி":"Tithi",v:lang==="ta"?"சுக்ல பக்ஷம்":"Shukla Paksha",icon:"&#9790;"},
              {l:lang==="ta"?"நட்சத்திரம்":"Nakshatra",v:lang==="ta"?nakshatras[today.getDate()%27].tamil:nakshatras[today.getDate()%27].name,icon:"&#11088;"},
              {l:lang==="ta"?"யோகம்":"Yoga",v:"Siddha",icon:"&#9775;"},
              {l:lang==="ta"?"கரணம்":"Karana",v:"Bava",icon:"&#9728;"},
              {l:lang==="ta"?"சூரிய உதயம்":"Sunrise",v:"6:02 AM",icon:"&#127774;"},
              {l:lang==="ta"?"சூரிய அஸ்தமனம்":"Sunset",v:"6:31 PM",icon:"&#127761;"},
            ].map((item,i) => (
              <div key={i} style={card}>
                <div style={{fontSize:"22px",marginBottom:"4px"}} dangerouslySetInnerHTML={{__html:item.icon}} />
                <div style={{color:"rgba(255,255,255,0.4)",fontSize:"9px",marginBottom:"3px"}}>{item.l}</div>
                <div style={{color:"#d4a843",fontWeight:700,fontSize:"12px"}}>{item.v}</div>
              </div>
            ))}
          </div>
          {secTitle(lang==="ta"?"இன்றைய காலங்கள்":"TODAY'S TIMINGS")}
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:"10px"}}>
            {[
              {l:lang==="ta"?"ராகு காலம்":"Rahu Kalam",v:rahuKalam[dayIndex],color:"#cc0000",note:lang==="ta"?"தவிர்க்கவும்":"Avoid"},
              {l:lang==="ta"?"எமகண்டம்":"Yamagandam",v:yamagandam[dayIndex],color:"#ff6600",note:lang==="ta"?"தவிர்க்கவும்":"Avoid"},
              {l:lang==="ta"?"குளிகை":"Gulikai",v:gulikai[dayIndex],color:"#ff9900",note:lang==="ta"?"தவிர்க்கவும்":"Avoid"},
              {l:lang==="ta"?"அபிஜித் முகூர்த்தம்":"Abhijit Muhurtham",v:"11:48 AM - 12:36 PM",color:"#00cc44",note:lang==="ta"?"சுபமான நேரம்":"Auspicious"},
            ].map((item,i) => (
              <div key={i} style={{...card,borderColor:item.color+"55"}}>
                <div style={{color:"rgba(255,255,255,0.5)",fontSize:"10px",marginBottom:"4px"}}>{item.l}</div>
                <div style={{color:item.color,fontWeight:900,fontSize:"14px"}}>{item.v}</div>
                <div style={{color:item.color,fontSize:"10px",marginTop:"3px"}}>{item.note}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {astroTab==="Calendar" && (
        <div>
          {secTitle(lang==="ta"?"பௌர்ணமி 2026":"POURNAMI 2026")}
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:"8px",marginBottom:"20px"}}>
            {pournami.map((p,i) => (
              <div key={i} style={{...card,borderColor:"rgba(255,255,200,0.25)",textAlign:"center"}}>
                <div style={{fontSize:"20px",marginBottom:"4px"}}>&#9790;</div>
                <div style={{color:"#fffde0",fontWeight:900,fontSize:"13px"}}>{p.date}</div>
                <div style={{color:"rgba(255,255,200,0.5)",fontSize:"10px"}}>{p.day}</div>
                <div style={{color:"#d4a843",fontSize:"11px",marginTop:"3px"}}>{p.tamil}</div>
              </div>
            ))}
          </div>
          {secTitle(lang==="ta"?"அமாவாசை 2026":"AMAVASAI 2026")}
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:"8px"}}>
            {amavasai.map((a,i) => (
              <div key={i} style={{...card,borderColor:"rgba(100,100,200,0.25)",textAlign:"center"}}>
                <div style={{fontSize:"20px",marginBottom:"4px"}}>&#127761;</div>
                <div style={{color:"#aaaaff",fontWeight:900,fontSize:"13px"}}>{a.date}</div>
                <div style={{color:"rgba(170,170,255,0.5)",fontSize:"10px"}}>{a.day}</div>
                <div style={{color:"#d4a843",fontSize:"11px",marginTop:"3px"}}>{a.tamil}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {astroTab==="Festivals" && (
        <div>
          {secTitle(lang==="ta"?"திருவிழாக்கள் 2026":"FESTIVALS 2026")}
          <div style={{display:"flex",flexDirection:"column",gap:"8px"}}>
            {festivals.map((f,i) => (
              <div key={i} style={{...card,display:"flex",gap:"14px",alignItems:"flex-start",borderLeft:"3px solid "+(f.type==="major"?"#d4a843":"#ff6600")}}>
                <div style={{minWidth:"55px"}}>
                  <div style={{color:"#d4a843",fontWeight:900,fontSize:"12px"}}>{f.date}</div>
                  <div style={{color:"rgba(255,255,255,0.3)",fontSize:"9px"}}>2026</div>
                </div>
                <div>
                  <div style={{display:"flex",gap:"8px",alignItems:"center",marginBottom:"3px",flexWrap:"wrap"}}>
                    <span style={{color:"#fff",fontWeight:700,fontSize:"13px"}}>{f.name}</span>
                    <span style={{color:"#d4a843",fontSize:"11px"}}>{f.tamil}</span>
                  </div>
                  <div style={{color:"rgba(255,255,255,0.55)",fontSize:"11px"}}>{lang==="ta"?f.tamilDesc:f.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {astroTab==="Rasi" && (
        <div>
          {secTitle(lang==="ta"?"12 ராசி ஜோதிடம்":"12 RASI HOROSCOPE")}
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(130px,1fr))",gap:"8px",marginBottom:"16px"}}>
            {rasis.map((r,i) => (
              <div key={i} onClick={()=>setSelectedRasi(selectedRasi===i?null:i)}
                style={{...card,cursor:"pointer",textAlign:"center",borderColor:selectedRasi===i?"#d4a843":"rgba(212,168,67,0.2)"}}>
                <div style={{fontSize:"26px",marginBottom:"4px"}} dangerouslySetInnerHTML={{__html:r.symbol}} />
                <div style={{color:"#d4a843",fontWeight:700,fontSize:"12px"}}>{lang==="ta"?r.tamil:r.name}</div>
                <div style={{color:"rgba(255,255,255,0.35)",fontSize:"9px"}}>{r.lord}</div>
              </div>
            ))}
          </div>
          {selectedRasi!==null && (
            <div style={{...card,borderColor:"#d4a843"}}>
              <div style={{display:"flex",gap:"12px",alignItems:"center",marginBottom:"10px",flexWrap:"wrap"}}>
                <span style={{fontSize:"32px"}} dangerouslySetInnerHTML={{__html:rasis[selectedRasi].symbol}} />
                <div>
                  <div style={{color:"#d4a843",fontWeight:900,fontSize:"16px"}}>{rasis[selectedRasi].name} | {rasis[selectedRasi].tamil}</div>
                  <div style={{color:"rgba(255,255,255,0.4)",fontSize:"11px"}}>{rasis[selectedRasi].lord} | {rasis[selectedRasi].element}</div>
                </div>
              </div>
              <div style={{background:"rgba(212,168,67,0.05)",borderRadius:"6px",padding:"10px"}}>
                <div style={{color:"#d4a843",fontSize:"10px",fontWeight:700,marginBottom:"5px"}}>{lang==="ta"?"இந்த வார கணிப்பு:":"THIS WEEK:"}</div>
                <div style={{color:"rgba(255,255,255,0.8)",fontSize:"12px",lineHeight:"1.6"}}>{lang==="ta"?rasis[selectedRasi].tamilPred:rasis[selectedRasi].pred}</div>
              </div>
            </div>
          )}
        </div>
      )}

      {astroTab==="Nakshatra" && (
        <div>
          {secTitle(lang==="ta"?"27 நட்சத்திரங்கள்":"27 NAKSHATRAS")}
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(190px,1fr))",gap:"8px"}}>
            {nakshatras.map((n,i) => (
              <div key={i} onClick={()=>setSelectedNakshatra(selectedNakshatra===i?null:i)}
                style={{...card,cursor:"pointer",borderColor:selectedNakshatra===i?"#d4a843":"rgba(212,168,67,0.2)"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div>
                    <div style={{color:"#d4a843",fontWeight:700,fontSize:"12px"}}>{i+1}. {lang==="ta"?n.tamil:n.name}</div>
                    <div style={{color:"rgba(255,255,255,0.35)",fontSize:"9px"}}>{n.planet}</div>
                  </div>
                  <span style={{fontSize:"16px"}}>&#11088;</span>
                </div>
                {selectedNakshatra===i && (
                  <div style={{marginTop:"8px",paddingTop:"8px",borderTop:"1px solid rgba(212,168,67,0.15)",color:"rgba(255,255,255,0.6)",fontSize:"11px"}}>{n.qualities}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {astroTab==="Rahu Kalam" && (
        <div>
          {secTitle(lang==="ta"?"வாராந்திர ராகு காலம்":"WEEKLY RAHU KALAM")}
          <div style={{overflowX:"auto"}}>
            <table style={{width:"100%",borderCollapse:"collapse",minWidth:"480px"}}>
              <thead>
                <tr style={{borderBottom:"1px solid rgba(212,168,67,0.25)"}}>
                  {["Day","Rahu Kalam","Yamagandam","Gulikai"].map(h => (
                    <th key={h} style={{color:"#d4a843",fontSize:"10px",fontWeight:700,padding:"8px 10px",textAlign:"left",letterSpacing:"1px"}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {days.map((day,i) => (
                  <tr key={i} style={{borderBottom:"1px solid rgba(255,255,255,0.04)",background:i===dayIndex?"rgba(212,168,67,0.07)":"transparent"}}>
                    <td style={{padding:"8px 10px",color:i===dayIndex?"#d4a843":"#fff",fontWeight:i===dayIndex?700:400,fontSize:"12px"}}>
                      {day}{i===dayIndex?" (Today)":""}
                      <div style={{color:"rgba(255,255,255,0.35)",fontSize:"9px"}}>{tamilDays[i]}</div>
                    </td>
                    <td style={{padding:"8px 10px",color:"#ff4444",fontSize:"11px"}}>{rahuKalam[i]}</td>
                    <td style={{padding:"8px 10px",color:"#ff9900",fontSize:"11px"}}>{yamagandam[i]}</td>
                    <td style={{padding:"8px 10px",color:"#ffcc00",fontSize:"11px"}}>{gulikai[i]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {astroTab==="Muhurtham" && (
        <div>
          {secTitle(lang==="ta"?"சுப முகூர்த்த நாட்கள்":"AUSPICIOUS DAYS 2026")}
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))",gap:"10px",marginBottom:"16px"}}>
            {[
              {type:lang==="ta"?"திருமண முகூர்த்தம்":"Marriage",dates:"Jan 20, Feb 14, Mar 8, Apr 22, May 15, Nov 12, Dec 3",icon:"&#128141;",color:"#ff69b4"},
              {type:lang==="ta"?"கிரஹ பிரவேசம்":"Gruha Pravesh",dates:"Jan 15, Feb 10, Mar 5, Apr 2, Nov 8, Dec 1",icon:"&#127968;",color:"#90ee90"},
              {type:lang==="ta"?"வாகன வாங்குதல்":"Vehicle Purchase",dates:"Jan 7, Feb 3, Mar 12, Apr 8, May 6",icon:"&#128664;",color:"#87ceeb"},
              {type:lang==="ta"?"தொழில் தொடக்கம்":"Business Start",dates:"Jan 22, Feb 18, Mar 16, Apr 13, May 11",icon:"&#128188;",color:"#ffd700"},
              {type:lang==="ta"?"கல்வி தொடக்கம்":"Education Start",dates:"Vijayadasami Oct 20, Any Thursday",icon:"&#128218;",color:"#ffa500"},
              {type:lang==="ta"?"நாமகரணம்":"Naming Ceremony",dates:"Any Monday, Wednesday, Thursday, Friday",icon:"&#128144;",color:"#dda0dd"},
            ].map((m,i) => (
              <div key={i} style={{...card,borderColor:m.color+"44"}}>
                <div style={{fontSize:"26px",marginBottom:"6px"}} dangerouslySetInnerHTML={{__html:m.icon}} />
                <div style={{color:m.color,fontWeight:700,fontSize:"12px",marginBottom:"5px"}}>{m.type}</div>
                <div style={{color:"rgba(255,255,255,0.55)",fontSize:"10px",lineHeight:"1.5"}}>{m.dates}</div>
              </div>
            ))}
          </div>
          {secTitle(lang==="ta"?"நல்ல & கெட்ட நாட்கள்":"GOOD & BAD DAYS")}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"12px"}}>
            <div style={{...card,borderColor:"rgba(0,200,0,0.25)"}}>
              <div style={{color:"#00cc44",fontWeight:700,fontSize:"12px",marginBottom:"8px"}}>&#9989; {lang==="ta"?"நல்ல நாட்கள்":"Good Days"}</div>
              {[["Monday","Moon Day"],["Wednesday","Mercury Day"],["Thursday","Jupiter - Best"],["Friday","Venus Day"]].map(([d,r],i) => (
                <div key={i} style={{marginBottom:"6px"}}>
                  <div style={{color:"#00cc44",fontWeight:700,fontSize:"11px"}}>{d}</div>
                  <div style={{color:"rgba(255,255,255,0.4)",fontSize:"9px"}}>{r}</div>
                </div>
              ))}
            </div>
            <div style={{...card,borderColor:"rgba(200,0,0,0.25)"}}>
              <div style={{color:"#cc0000",fontWeight:700,fontSize:"12px",marginBottom:"8px"}}>&#10060; {lang==="ta"?"தவிர்க்க வேண்டியவை":"Days to Avoid"}</div>
              {[["Tuesday","Avoid new ventures"],["Saturday","Avoid loans"],["Amavasai","No new starts"],["Rahu Kalam","Avoid all work"]].map(([d,r],i) => (
                <div key={i} style={{marginBottom:"6px"}}>
                  <div style={{color:"#cc0000",fontWeight:700,fontSize:"11px"}}>{d}</div>
                  <div style={{color:"rgba(255,255,255,0.4)",fontSize:"9px"}}>{r}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {astroTab==="Learn" && (
        <div>
          {secTitle(lang==="ta"?"ஜோதிட அறிவியல்":"ASTROLOGY SCIENCE")}
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",gap:"12px"}}>
            {[
              {title:lang==="ta"?"பஞ்சாங்கம் என்றால் என்ன?":"What is Panchangam?",icon:"&#9737;",content:lang==="ta"?"பஞ்சாங்கம் என்பது ஐந்து அங்கங்களைக் கொண்ட இந்து காலண்டர். திதி, வாரம், நட்சத்திரம், யோகம், கரணம் ஆகியவை ஐந்து அங்கங்கள். சுப முகூர்த்தங்களை தீர்மானிக்க பயன்படுகிறது.":"Panchangam is the Hindu almanac with 5 elements: Tithi, Vara, Nakshatra, Yoga, and Karana. Used to determine auspicious times for all life events."},
              {title:lang==="ta"?"12 ராசிகள் பற்றி":"About 12 Rashis",icon:"&#9800;",content:lang==="ta"?"12 ராசிகள் வானத்தை சம பாகங்களாக பிரிக்கின்றன. ஒவ்வொரு ராசியும் ஒரு கிரகத்தால் ஆளப்படுகிறது. நம் பிறப்பு நேரத்தில் சூரியன் எந்த ராசியில் இருக்கிறதோ அதுவே நம் ராசி.":"The 12 zodiac signs divide the sky into equal parts. Each sign is ruled by a planet. Your rasi is determined by the Sun position at your birth time."},
              {title:lang==="ta"?"27 நட்சத்திரங்கள்":"27 Nakshatras",icon:"&#11088;",content:lang==="ta"?"27 நட்சத்திரங்கள் சந்திரனின் பாதையை வரையறுக்கின்றன. பிறந்த நேரத்தில் சந்திரன் எந்த நட்சத்திரத்தில் இருக்கிறதோ அதுவே பிறந்த நட்சத்திரம். இது ஆளுமை மற்றும் விதியை தீர்மானிக்கிறது.":"27 nakshatras define the Moon path. Your birth nakshatra is where the Moon was at your birth time. It determines personality traits and life destiny."},
              {title:lang==="ta"?"ராகு காலம் ஏன் முக்கியம்?":"Why is Rahu Kalam Important?",icon:"&#9888;",content:lang==="ta"?"ராகு ஒரு நிழல் கிரகம். ராகு காலத்தில் இந்த கிரகத்தின் தாக்கம் அதிகமாக இருக்கும். இந்த நேரத்தில் தொடங்கும் காரியங்கள் தடைகளை சந்திக்கும் என்று நம்பப்படுகிறது.":"Rahu is a shadow planet. During Rahu Kalam its influence is at peak. Activities started during this time are believed to face obstacles and delays."},
              {title:lang==="ta"?"முகூர்த்தம் என்றால் என்ன?":"What is Muhurtham?",icon:"&#128336;",content:lang==="ta"?"முகூர்த்தம் என்பது ஒரு சுபமான நேரம். திருமணம், கிரஹ பிரவேசம், தொழில் தொடக்கம் போன்றவற்றுக்கு சரியான முகூர்த்தம் தேர்ந்தெடுப்பது வெற்றியை உறுதி செய்யும்.":"Muhurtham is an auspicious time window. Choosing the right muhurtham for important life events like marriage and housewarming ensures success."},
              {title:lang==="ta"?"9 கிரகங்கள்":"9 Planets (Grahas)",icon:"&#127756;",content:lang==="ta"?"சூரியன், சந்திரன், செவ்வாய், புதன், குரு, சுக்கிரன், சனி, ராகு, கேது ஆகிய 9 கிரகங்கள் மனித வாழ்க்கையை பாதிக்கின்றன. ஒவ்வொரு கிரகமும் வாழ்க்கையின் ஒரு அம்சத்தை நிர்வகிக்கிறது.":"The 9 planets Sun, Moon, Mars, Mercury, Jupiter, Venus, Saturn, Rahu and Ketu influence human life. Each planet governs a specific aspect of life."},
            ].map((item,i) => (
              <div key={i} style={card}>
                <div style={{fontSize:"24px",marginBottom:"6px"}} dangerouslySetInnerHTML={{__html:item.icon}} />
                <div style={{color:"#d4a843",fontWeight:700,fontSize:"13px",marginBottom:"6px"}}>{item.title}</div>
                <div style={{color:"rgba(255,255,255,0.65)",fontSize:"11px",lineHeight:"1.6"}}>{item.content}</div>
              </div>
            ))}
          </div>
        </div>
      )}
      <div style={{padding:'16px',borderTop:'1px solid rgba(255,255,255,0.08)'}}>
        <div style={{color:'rgba(255,255,255,0.4)',fontSize:'11px',fontWeight:'700',letterSpacing:'2px',marginBottom:'12px'}}>ASTROLOGY SERVICES</div>
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(140px,1fr))',gap:'10px'}}>
          {[{name:'Jathagam',url:'https://jathagam.com',desc:'Tamil jathagam',color:'#ff6600',emoji:'🔮'},{name:'AstroSage',url:'https://astrosage.com',desc:'Free horoscope',color:'#8B4513',emoji:'⭐'},{name:'Clickastro',url:'https://clickastro.com',desc:'Marriage matching',color:'#9b59b6',emoji:'💍'},{name:'GaneshaSpeaks',url:'https://ganeshaspeaks.com',desc:'Daily predictions',color:'#e67e22',emoji:'🐘'}].map((a,i)=>(
            <div key={i} onClick={()=>window.open(a.url,'_blank')} style={{background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.08)',borderRadius:'10px',padding:'12px',cursor:'pointer',borderTop:'2px solid '+a.color,textAlign:'center'}}>
              <div style={{fontSize:'22px',marginBottom:'4px'}}>{a.emoji}</div>
              <div style={{color:a.color,fontWeight:'800',fontSize:'12px',marginBottom:'3px'}}>{a.name}</div>
              <div style={{color:'rgba(255,255,255,0.35)',fontSize:'10px',marginBottom:'8px'}}>{a.desc}</div>
              <button style={{padding:'4px 10px',background:a.color,border:'none',borderRadius:'5px',color:'#fff',fontWeight:'700',cursor:'pointer',fontSize:'10px'}}>Open</button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AstrologyContent;
